// packages/shared/src/types/onboardingChecklist.ts
export const UNIFIED_CHECKLIST_VERSION = 'checklist-2026-11';
/**
 * The only steps a read-only seat (GUEST) can complete. A guest cannot write
 * (import, equipment, a protocol run, a connection, an invitation, a phone
 * capture) and cannot hold the Bower chat panel (`canHoldBird`), so every other
 * step would be a dead end. The server leaves the rest out of a read-only
 * seat's view (a seat demoted after enrolment included), and the client
 * filters by the same set.
 */
export const CHECKLIST_READ_ONLY_STEPS = new Set([
    'open_start_here',
]);
/**
 * The checklist-2026-11 step sets (usability plan 2026-10-29, Workstream D).
 * Pure, so enrolment and the tests agree on one table.
 */
export function resolveUnifiedChecklistSteps(variant, workspace) {
    if (variant === 'viewer') {
        return { coreSteps: [...CHECKLIST_READ_ONLY_STEPS], bonusSteps: [] };
    }
    if (variant === 'invitee') {
        return {
            coreSteps: [
                'ask_bird',
                'open_start_here',
                'run_protocol',
                'import_first_file',
                ...(workspace.workspaceHasEquipment ? [] : ['capture_equipment']),
                'mobile_capture',
            ],
            bonusSteps: ['connect_source'],
        };
    }
    return {
        coreSteps: [
            'ask_bird',
            ...(workspace.seeded ? ['open_start_here'] : []),
            'import_first_file',
            'run_protocol',
            'capture_equipment',
            'mobile_capture',
        ],
        bonusSteps: ['connect_source', 'invite_teammate'],
    };
}
// Versioned config — add new version keys here when checklist changes.
// Existing enrolled users stay on their enrolled version; only new
// enrolments get CURRENT_CHECKLIST_VERSION.
export const CHECKLIST_CONFIGS = {
    'checklist-2026-03': {
        coreSteps: [
            'workspace_created',
            'import_first_file',
            'ask_bird',
            'create_collection',
            'mobile_capture',
            'live_agent_teaser',
            'invite_teammate',
        ],
        bonusItems: [],
    },
    // v2 (onboarding hero-journey spec): endowed progress via the
    // pre-completed identity step; create_collection dropped (weak
    // activation signal); invite_teammate moved OUT of core — it needs
    // social capital and blocked every all-complete (0/31 users in 90d).
    // Core completion = the 6 steps below; invite renders as a bonus row.
    'checklist-2026-07': {
        coreSteps: [
            'bird_knows_you',
            'import_first_file',
            'ask_bird',
            'capture_equipment',
            'mobile_capture',
            'live_agent_teaser',
        ],
        bonusItems: ['invite_teammate'],
    },
};
export const CURRENT_CHECKLIST_VERSION = 'checklist-2026-07';
//# sourceMappingURL=onboardingChecklist.js.map